import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { compose, graphql } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import BackIcon from '@material-ui/icons/ArrowBack'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'
import { styles } from './styles'
import Title from '../../components/Title'
import { withContext } from '../../context'
import { Col, Popconfirm, Row, Space, Tag } from 'antd'
import { GET_MATERIAL_LIST } from '../../graphql/queries'
import { ButtonEx, CardContentEx, TableEx } from '../../shared.style'
import { CardMaterialEx } from '../../material.style'
import { isMobile, toBuddhistYear } from '../../utils'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { getMaterials } from '../../stores/material'
import moment from 'moment'
import { ACTION } from '../../utils/constants'
import ManageAnnouncement from './ManageAnnouncement'
import {
  deleteAnnouncement,
  fetchAnnouncementList
} from '../../stores/announcement'
import { numberWithCommas } from '../../utils/number'

export const AccountFactory = ({
  history: { push, goBack },
  context: { state },
  me
}) => {
  const dispatch = useDispatch()
  const [actionState, setActionState] = useState(ACTION.LIST)
  const [factoryState, setFactoryState] = useState({})

  const { isLoading, announcementList } = useSelector(
    (state) => state.announcement
  )

  useDeepEffect(() => {
    async function fetchData() {
      await dispatch(getMaterials())
      await dispatch(
        fetchAnnouncementList({
          heroId: me.id
        })
      )
    }

    fetchData()
  }, [])

  function onClick(e, action) {
    e.preventDefault()
    setActionState(action)
  }

  function onEdit(record) {
    setFactoryState(record)
    setActionState(ACTION.EDIT)
  }

  async function onClickDelete(id) {
    await dispatch(deleteAnnouncement(id))
    await dispatch(
      fetchAnnouncementList({
        heroId: me.id
      })
    )
  }

  const columns = [
    {
      title: 'วันที่ประกาศ',
      dataIndex: 'updatedDate',
      align: 'center',
      render: (text, record) => {
        return toBuddhistYear(
          moment.unix((text !== null ? text : record.createdDate) / 1000),
          'LL'
        )
      }
    },
    {
      title: 'ชนิดการประกาศ',
      dataIndex: 'announcementType',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'วัสดุที่รับ',
      dataIndex: 'material',
      align: 'center',
      render: (text) => <span>{text.name || '-'}</span>
    },
    {
      title: 'ราคาที่รับ',
      dataIndex: 'price',
      align: 'center',
      render: (text) => <span>{numberWithCommas(text, 2) || '-'}</span>
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      align: 'center',
      render: (text) =>
        text ? (
          <Tag color="#6ebf4b">ประกาศ</Tag>
        ) : (
          <Tag color="red">หมดอายุ</Tag>
        )
    },
    {
      title: 'Action',
      align: 'center',
      render: (text, record) => {
        return (
          <Space>
            <a onClick={() => onEdit(record)}>แก้ไข</a>
            <Popconfirm
              title="ยืนยันการลบ?"
              onConfirm={() => onClickDelete(record.id)}>
              <a>ลบ</a>
            </Popconfirm>
          </Space>
        )
      }
    }
  ]

  function setBack(action) {
    setActionState(action)
  }

  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            style={styles.menuButton}
            onClick={() => push(`/`)}>
            <BackIcon />
          </IconButton>
          <Typography
            id="titlePage"
            variant="h6"
            color="inherit"
            style={styles.grow}>
            หน้าหลัก
          </Typography>
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
        {state.uploading ? (
          <LinearProgress />
        ) : (
          <div style={{ height: '4px' }} />
        )}
      </AppBar>
      {actionState === ACTION.LIST && <Title name="ประกาศของคุณ" />}
      {actionState === ACTION.CREATE && <Title name="สร้างประกาศ" />}
      {actionState === ACTION.EDIT && <Title name="แก้ไขประกาศ" />}
      <CardMaterialEx width={1000} elevation={isMobile ? 0 : 1} square>
        <CardContentEx>
          {actionState === ACTION.LIST && (
            <div>
              <TableEx
                loading={isLoading}
                bordered
                rowKey={(record) => {
                  return record.id
                }}
                dataSource={announcementList}
                columns={columns}
              />
              <Row gutter={8} style={{ marginTop: 10 }} justify="center">
                <Col>
                  <ButtonEx
                    color="#707070"
                    type="primary"
                    onClick={() => goBack()}>
                    กลับ
                  </ButtonEx>
                </Col>
                {me.status === 'APPROVED' && (
                  <Col>
                    <ButtonEx
                      color="#6ebf4b"
                      type="primary"
                      onClick={(e) => onClick(e, ACTION.CREATE)}>
                      เพิ่มประกาศ
                    </ButtonEx>
                  </Col>
                )}
              </Row>
            </div>
          )}
          {(actionState === ACTION.CREATE || actionState === ACTION.EDIT) && (
            <ManageAnnouncement
              heroId={me.id}
              actionState={actionState}
              setActionState={setActionState}
              setBack={setBack}
              factoryState={factoryState}
            />
          )}
        </CardContentEx>
      </CardMaterialEx>
    </React.Fragment>
  )
}

AccountFactory.propTypes = {
  history: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired
}

export default compose(
  withRouter,
  withContext,
  graphql(GET_MATERIAL_LIST)
)(AccountFactory)



// WEBPACK FOOTER //
// ./src/pages/AccountFactory/index.js